export const VERSION_NUMBER = '1.302';
export const BUILD_TIME = '2025-05-27T13:38:31.467Z';
export const BUILD_NOTES = "<ul><li>Updated multiple state driver's license regexes.</li></ul>";
